import styled from 'styled-components';

import {
  StyledTabs as BaseStyledTabs,
  StyledTab as BaseStyledTab,
  TabsContainer as BaseTabsContainer,
} from 'components/Tabs/styles';

export const TabsContainer = styled(BaseTabsContainer)`
  padding: 10px 0px 0px 0px;
  background: inherit;
  overflow-y: auto;
`;

export const StyledTabs = styled(BaseStyledTabs)`
  margin-bottom: 0;
  border-bottom: none;
  background-color: white;
  padding: 20px;
  padding-bottom: 0px;
  padding-top: 0px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 8px 8px 0 0;
`;

export const StyledTab = styled(BaseStyledTab)`
  min-height: 42px;
`;
